import LegalHeader from "@/components/LegalHeader";
import Footer from "@/components/Footer";

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <LegalHeader />
      <main className="pt-20 pb-16">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-primary mb-4">
                Cookie Policy
              </h1>
              <p className="text-muted-foreground">
                Ultimo aggiornamento: 16 marzo 2026
              </p>
            </div>

            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">1. Cosa sono i Cookie</h2>
                <p>
                  I cookie sono piccoli file di testo che vengono memorizzati sul Suo dispositivo (computer, tablet, smartphone) quando visita il nostro sito web. I cookie permettono al sito di "ricordare" le Sue azioni e preferenze per un periodo di tempo limitato.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">2. Cookie Utilizzati dal Sito</h2>

                <h3 className="text-xl font-semibold text-primary mb-3">2.1 Cookie Tecnici (Necessari)</h3>
                <p>Questi cookie sono essenziali per il funzionamento del sito web e non richiedono il consenso dell'utente:</p>
                <div className="overflow-x-auto mt-4 mb-6">
                  <table className="min-w-full border border-border text-sm">
                    <thead>
                      <tr className="bg-muted">
                        <th className="border border-border px-4 py-2 text-left">Nome Cookie</th>
                        <th className="border border-border px-4 py-2 text-left">Fornitore</th>
                        <th className="border border-border px-4 py-2 text-left">Finalità</th>
                        <th className="border border-border px-4 py-2 text-left">Durata</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-border px-4 py-2"><code>armando-cookie-consent-v3</code></td>
                        <td className="border border-border px-4 py-2">Questo sito (localStorage)</td>
                        <td className="border border-border px-4 py-2">Memorizza le preferenze di consenso cookie dell'utente</td>
                        <td className="border border-border px-4 py-2">Persistente (fino a cancellazione manuale)</td>
                      </tr>
                      <tr>
                        <td className="border border-border px-4 py-2"><code>sb-*-auth-token</code></td>
                        <td className="border border-border px-4 py-2">Supabase (localStorage)</td>
                        <td className="border border-border px-4 py-2">Autenticazione per l'area riservata di amministrazione del sito</td>
                        <td className="border border-border px-4 py-2">Sessione / fino a logout</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 className="text-xl font-semibold text-primary mb-3 mt-6">2.2 Cookie di Terze Parti (Funzionali)</h3>
                <p>Il sito offre la possibilità di caricare una mappa interattiva di Google Maps nella sezione "Dove Siamo". La mappa viene caricata <strong>solo dopo il consenso esplicito dell'utente</strong> tramite il pulsante "Carica Mappa".</p>
                <div className="overflow-x-auto mt-4 mb-6">
                  <table className="min-w-full border border-border text-sm">
                    <thead>
                      <tr className="bg-muted">
                        <th className="border border-border px-4 py-2 text-left">Nome Cookie</th>
                        <th className="border border-border px-4 py-2 text-left">Fornitore</th>
                        <th className="border border-border px-4 py-2 text-left">Finalità</th>
                        <th className="border border-border px-4 py-2 text-left">Durata</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-border px-4 py-2"><code>NID</code>, <code>CONSENT</code>, <code>1P_JAR</code>, <code>SOCS</code></td>
                        <td className="border border-border px-4 py-2">Google (google.com)</td>
                        <td className="border border-border px-4 py-2">Cookie impostati dall'embed di Google Maps per funzionalità e preferenze della mappa</td>
                        <td className="border border-border px-4 py-2">6 mesi — 2 anni (varia per cookie)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p>
                  Per maggiori informazioni sui cookie di Google:{" "}
                  <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer" className="text-gold underline">
                    Privacy Policy di Google
                  </a>.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">3. Cookie NON utilizzati</h2>
                <p>
                  Il presente sito <strong>non utilizza</strong> cookie analitici (es. Google Analytics), cookie di profilazione, cookie pubblicitari o cookie di social media. Non vengono effettuate attività di tracciamento dell'utente a fini di marketing o profilazione.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">4. Gestione dei Cookie</h2>
                <p>
                  Può gestire le Sue preferenze sui cookie in qualsiasi momento tramite il pulsante delle impostazioni cookie presente nell'angolo in basso a sinistra del sito.
                </p>
                <p className="mt-4">Può inoltre gestire i cookie attraverso le impostazioni del Suo browser:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Chrome:</strong> Impostazioni &rarr; Privacy e sicurezza &rarr; Cookie</li>
                  <li><strong>Firefox:</strong> Opzioni &rarr; Privacy e sicurezza &rarr; Cookie</li>
                  <li><strong>Safari:</strong> Preferenze &rarr; Privacy &rarr; Cookie</li>
                  <li><strong>Edge:</strong> Impostazioni &rarr; Cookie e autorizzazioni sito</li>
                </ul>
                <p className="mt-4">La disattivazione dei cookie tecnici potrebbe limitare la funzionalità del sito (es. area di amministrazione).</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">5. Base Giuridica</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Cookie tecnici:</strong> legittimo interesse del titolare e necessità per il funzionamento del sito (art. 122, comma 1, D.Lgs. 196/2003; Linee Guida Garante Privacy 10 giugno 2021)</li>
                  <li><strong>Cookie di terze parti (Google Maps):</strong> consenso dell'utente (art. 122 D.Lgs. 196/2003; art. 6(1)(a) GDPR)</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">6. Aggiornamenti della Policy</h2>
                <p>Questa Cookie Policy può essere aggiornata periodicamente. Le modifiche saranno pubblicate su questa pagina con la data di ultimo aggiornamento.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">7. Titolare del Trattamento e Contatti</h2>
                <p>
                  <strong>Ristorante Da Armando</strong><br />
                  Via Aganoor Pompili, 25 — 06065 Passignano sul Trasimeno (PG)<br />
                  P.IVA: 03963890540
                </p>
                <ul className="list-disc pl-6 space-y-2 mt-4">
                  <li>Email: info@ristorantearmando.it</li>
                  <li>Telefono: +39 075 388 0397</li>
                </ul>
                <p className="mt-4">
                  Per proporre reclamo, può rivolgersi al <strong>Garante per la Protezione dei Dati Personali</strong>: Piazza Venezia 11, 00187 Roma —{" "}
                  <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-gold underline">
                    www.garanteprivacy.it
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CookiePolicy;
